import { svg } from 'lit';
export const circle16Svg = svg `
<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_166_35507)">
        <path d="M8 15C11.866 15 15 11.866 15 8C15 4.13401 11.866 1 8 1C4.13401 1 1 4.13401 1 8C1 11.866 4.13401 15 8 15Z" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </g>
    <defs>
        <clipPath id="clip0_166_35507">
            <rect width="16" height="16"/>
        </clipPath>
    </defs>
</svg>
`;
//# sourceMappingURL=circle_16.svg.js.map